import { render, staticRenderFns } from "./UpdatePititimPrice.vue?vue&type=template&id=338ea9b0"
import script from "./UpdatePititimPrice.vue?vue&type=script&lang=js"
export * from "./UpdatePititimPrice.vue?vue&type=script&lang=js"
import style0 from "./UpdatePititimPrice.vue?vue&type=style&index=0&id=338ea9b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports